module.exports = __webpack_public_path__ + "img/app-store.52b96bac.svg";